function styleShadowForm() {
  const formContainer = document.querySelector('.shopify-form-embed-section');
  if (!formContainer) return;
  
  // Only target shadow DOM - the actual form content
  const formEmbed = formContainer.querySelector('form-embed');
  if (formEmbed?.shadowRoot) {
    // Check if screen is below 600px
    const isMobile = window.matchMedia('(max-width: 600px)').matches;
    
    // Style ALL elements in shadow DOM
    formEmbed.shadowRoot.querySelectorAll('*').forEach(el => {
      // Apply font styling to everything
      el.style.setProperty('color', '#666', 'important');
      el.style.setProperty('font-family', 'var(--font-stack-body)', 'important');
      el.style.setProperty('font-size', 'calc(((var(--font-h6-mobile)) / (var(--font-base-size))) * 1rem)', 'important');
      
      // Header paragraphs get extra weight
      if (el.tagName === 'P' && el.textContent?.includes('To register your product')) {
        el.style.setProperty('font-weight', '600', 'important');
        el.style.setProperty('line-height', '1.5', 'important');
      }
      
      if (el.tagName === 'P' && el.textContent?.includes('submitting')) {
        el.style.setProperty('line-height', '1.5', 'important');
        el.style.setProperty('font-size', '16px', 'important');
      }
      
      // RESPONSIVE TEXTAREA STYLING
      if (el.tagName === 'TEXTAREA') {
        el.style.setProperty('font-size', '16px', 'important');
        
        // Different padding based on screen size
        if (isMobile) {
          el.style.setProperty('padding-top', '50px', 'important'); // Less padding on mobile
        } else {
          el.style.setProperty('padding-top', '45px', 'important'); // Original padding on desktop
        }
      }
      
      if (el.tagName === 'LABEL' && el.textContent?.includes('Description')) {
        el.style.setProperty('font-size', '16px', 'important');
      }
      
      if (el.tagName === 'BUTTON') {
        el.style.setProperty('color', '#fff', 'important');
      }
      
      // Special styling for form labels
      if (el.tagName === 'LABEL') {
        el.style.setProperty('line-height', '1.5', 'important');
        el.style.setProperty('top', '12px', 'important');
      }
    });
    
    console.log(`Styled shadow DOM elements - Mobile: ${isMobile}`);
  } else {
    console.log('Shadow DOM not found yet');
  }
}

// Listen for window resize to reapply styles when screen size changes
const mediaQuery = window.matchMedia('(max-width: 600px)');
mediaQuery.addListener(styleShadowForm); // Re-run when media query changes

// Run and monitor - shadow DOM loads after regular DOM
styleShadowForm();
setTimeout(styleShadowForm, 1000);
setTimeout(styleShadowForm, 2000);

// Monitor for shadow DOM creation
new MutationObserver(() => {
  setTimeout(styleShadowForm, 100);
}).observe(document.body, {
  childList: true,
  subtree: true
});

// Ensure it runs when ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', styleShadowForm);
}